const messages = {
  'p.login.error':
    "Something went wrong and we can't sign you in right now. Please try again.",
  'p.login.welcome': '欢迎访问ABB EL China Digital Express Management System',
  'p.login.employee': 'ABB员工',
  'p.login.employeetip': '使用ABB邮箱登录',
  'p.login.customer': 'ABB客户',
  'p.login.customertip': '查询我的订单',
  'p.errorpage.401': '未授权',
  'p.errorpage.403': '禁止访问',
  'p.errorpage.404': '未找到页面',
  'p.errorpage.home': '返回主页',
  'p.table.action': '操作',
  'p.table.status': '状态',
  'p.table.lastupdatedby': '最后更新者',
  'p.table.lastupdatedtime': '最后更新时间',
  'p.table.remark': '备注',
  'p.masterdata.type': '数据类型',
  'p.masterdata.text': '数据文本',
  'p.masterdata.value': '数据值',
  'p.masterdata.mappingkey': '映射键',
  'p.masterdata.mappingkey2': '映射键2',
  'p.masterdata.IsEnabled': '是否启用',
  'p.masterdata.displayindex': '显示索引',
  'p.masterdata.createtitle': '创建',
  'p.masterdata.edittitle': '更新',
  'p.action.deleteconfirmtitle': '您确定要删除此数据吗？',
  'p.action.authorizeconfirmtitle': '您确定要发起授权吗？',
  'p.action.logoutconfirmtitle': '退出是否安全？',
  'p.action.optionconfirmtitle': '您确定要执行此操作吗？',
  'p.emailtemplate.classify': '分类',
  'p.emailtemplate.name': '名称',
  'p.emailtemplate.code': '代码',
  'p.emailtemplate.subjecttemplate': '主题',
  'p.emailtemplate.bodytemplate': '内容',
  'p.emailtemplate.createtitle': '创建',
  'p.emailtemplate.edittitle': '更新',
  'p.table.createdby': '创建者',
  'p.table.createdtime': '创建时间',
  'p.carriers.no':'编号',
  'p.carriers.shippingtype':'运输类型',
  'p.carriers.name':'名称',
  'p.carriers.code':'代码',
  'p.carriers.carriername':'承运商名称',
  'p.carriers.carriercode':'承运商代码',
  'p.carriers.account':'账户',
  'p.carriers.password':'密码',
  'p.carriers.isenabled':'是否启用',
  'p.carriers.updatedate':'更新时间',
  'p.carriers.createtitle': '创建',
  'p.carriers.edittitle': '更新',
  'p.paymentaccount.title':'支付账户列表',
  'p.paymentaccount.no':'编号',
  'p.paymentaccount.company': '公司',
  'p.paymentaccount.signedcarriername': '签署的承运商名称',
  'p.paymentaccount.signedcarriercode': '签署的承运商代码',
  'p.paymentaccount.taxcode': '税号',
  'p.paymentaccount.carrier': '承运商',
  'p.paymentaccount.carriername': '承运商名称',
  'p.paymentaccount.companyname':'公司名称',
  'p.paymentaccount.companycode':'公司代码',
  'p.paymentaccount.name':'账户名称',
  'p.paymentaccount.number':'账户号码',
  'p.paymentaccount.isenabled':'是否启用',
  'p.paymentaccount.updatedate':'更新时间',
  'p.paymentaccount.createtitle': '创建',
  'p.paymentaccount.edittitle': '更新',
  'p.carrieraccount.title':'承运商账户列表',
  'p.carrieraccount.no':'编号',
  'p.carrieraccount.company': '公司',
  'p.carrieraccount.carrier': '承运商',
  'p.carrieraccount.carriername': '承运商名称',
  'p.carrieraccount.companyname':'公司名称',
  'p.carrieraccount.companycode':'公司代码',
  'p.carrieraccount.accounttype': '账户类型',
  'p.carrieraccount.account':'账户',
  'p.carrieraccount.accountname':'账户名称',
  'p.carrieraccount.password':'密码',
  'p.carrieraccount.appkey': '应用密钥',
  'p.carrieraccount.appsecret': '应用密钥',
  'p.carrieraccount.aessecret': 'AES 密钥',
  'p.carrieraccount.uselevel': '使用级别',
  'p.carrieraccount.tokenExpirationTime': '访问令牌过期时间',
  'p.carrieraccount.isenabled':'是否启用',
  'p.carrieraccount.updatedate':'更新时间',
  'p.carrieraccount.createtitle': '创建',
  'p.carrieraccount.edittitle': '更新',
  'p.freightbillaccount.company': '公司',
  'p.freightbillaccount.carrier': '承运商',
  'p.freightbillaccount.carriername': '承运商名称',
  'p.freightbillaccount.companyname':'公司名称',
  'p.freightbillaccount.companycode':'公司代码',
  'p.freightbillaccount.synctype': '同步类型',
  'p.freightbillaccount.account':'账户',
  'p.freightbillaccount.accountname':'账户名称',
  'p.freightbillaccount.password':'密码',
  'p.freightbillaccount.sftphost': 'SFtp 主机',
  'p.freightbillaccount.sftpport': 'SFtp 端口',
  'p.freightbillaccount.sftpremotepath': 'SFtp 远程路径',
  'p.freightbillaccount.isenabled':'是否启用',
  'p.freightbillaccount.createtitle': '创建',
  'p.freightbillaccount.edittitle': '更新',
  'p.purchaserequest.requestno':'请求编号',
  'p.purchaserequest.podocumentno':'PO 编号',
  'p.purchaserequest.applicant':'申请人',
  'p.purchaserequest.applicantdate':'申请日期',
  'p.purchaserequest.status':'状态',
  'p.purchaserequest.carrier':'承运商',
  'p.purchaserequest.billingmonth':'账单月份',
  'p.purchaserequest.company':'公司',
  'p.purchaserequest.totalamount':'总金额',
  'p.purchaserequest.currency':'货币',
  'p.purchaserequest.signedcarrier':'承运商编号',
  'p.purchaserequest.plant':'工厂',
  'p.purchaserequest.department':'部门',
  'p.purchaserequest.area.basicinfo': '基本信息',
  'p.purchaserequest.confirmer': '账单确认人',
  'p.purchaserequest.vendorno': '供应商编号',
  'p.purchaserequest.taxcode': '税号',
  'p.purchaserequest.purchasegroup': '采购组',
  'p.purchaserequest.mdfcode': 'MDF 代码',
  'p.purchaserequest.remark': '备注',
  'p.purchaserequest.area.detailinfo': '详细信息',
  'p.purchaserequest.area.prchange': 'PR 项目变更请求列表',
  'p.purchaserequest.itemno': '项目编号',
  'p.purchaserequest.costobjecttype': '成本对象类型',
  'p.purchaserequest.costobject': '成本对象',
  'p.purchaserequest.amount': '总金额（含税）',
  'p.purchaserequest.netamount': '净价',
  'p.purchaserequest.materialgroup': '物料组',
  'p.purchaserequest.businessfunction': '业务功能',
  'p.purchaserequest.area.processinfotitle': '审批处理',
  'p.purchaserequest.area.approvalloginfotitle': '审批历史',
  'p.purchaserequest.canceltitle': '取消',
  'p.purchaserequest.reasons': '原因',
  'p.shipments.dnno':'DN 编号',
  'p.shipments.status':'状态',
  'p.shipments.dnstatus':'DN 状态',
  'p.shipments.trackingno':'追踪编号',
  'p.shipments.tcpno':'TCP 编号',
  'p.shipments.type':'类型',
  'p.shipments.shipmentcreatedate':'发货创建日期',
  'p.shipments.submittedby':'提交人',
  'p.shipments.carrier':'承运商',
  'p.shipments.carriername': '承运商名称',
  'p.shipments.company':'公司',
  'p.shipments.deliverydate':'交货日期',
  'p.shipments.basicinformation':'基本信息',
  'p.shipments.dn':'DN',
  'p.shipments.submitdate':'提交日期',
  'p.shipments.pricerule':'价格规则',
  'p.shipments.creator':'创建人',
  'p.shipments.pg':'PG',
  'p.shipments.mobile':'手机',
  'p.shipments.transportationtype':'运输类型',
  'p.shipments.plantcode':'工厂代码',
  'p.shipments.costobject':'成本对象',
  'p.shipments.declaredvalue':'申报价值',
  'p.shipments.unitofmeasurement':'计量单位',
  'p.shipments.currency':'货币',
  'p.shipments.incoterm':'国际贸易术语',
  'p.shipments.shipperdetails':'发货人详细信息',
  'p.shipments.countrycode':'国家/地区代码',
  'p.shipments.province':'省',
  'p.shipments.city':'市',
  'p.shipments.postalcode':'邮政编码',
  'p.shipments.address':'地址',
  'p.shipments.contract':'联系人',
  'p.shipments.companyname':'公司名称',
  'p.shipments.tel':'电话',
  'p.shipments.email':'电子邮件',
  'p.shipments.receiverdetails':'收件人详细信息',
  'p.shipments.cargodetails':'货物详细信息',
  'p.shipments.huno':'HU 编号',
  'p.shipments.length':'长度',
  'p.shipments.width':'宽度',
  'p.shipments.height':'高度',
  'p.shipments.weight':'重量',
  'p.shipments.itemno':'项目编号',
  'p.shipments.count':'数量',
  'p.shipments.materialdescription':'物料描述',
  'p.shipments.material':'物料',
  'p.shipments.serialno':'序列号',
  'p.shipments.price':'价格',
  'p.shipments.quantity':'数量',
  'p.shipments.hscode':'HS编码',
  'p.shipments.itemdetails':'项目详细信息',
  'p.shipments.duties':'关税',
  'p.shipments.ordercreatedate':'发货订单创建日期',
  'p.shipments.createdtime': '创建时间',
  'p.freight.uploadbillingfile':'上传账单文件',
  'p.fedexfreightbill.ordernumber': '订单编号',
  'p.fedexfreightbill.referenceno': '参考编号',
  'p.fedexfreightbill.trackingno':'追踪编号',
  'p.fedexfreightbill.invoiceno':'预开发票编号',
  'p.fedexfreightbill.freight':'运费',
  'p.fedexfreightbill.fuelsurcharge':'燃油附加费',
  'p.fedexfreightbill.otherscharge': '其他费用',
  'p.fedexfreightbill.amount': '金额',
  'p.fedexfreightbill.currency': '货币',
  'p.fedexfreightbill.shipmentdate': '发货日期',
  'p.fedexfreightbill.receivercountrycode': '目的国',
  'p.fedexfreightbill.shippercity': '发货城市',
  'p.fedexfreightbill.receivercity': '收件城市',
  'p.fedexfreightbill.billingmonth': '账单月份',
  'p.fedexfreightbill.company': '公司',
  'p.fedexfreightbill.monthlycard': '月度卡',
  'p.fedexfreightbill.status': '状态',
  'p.fedexfreightbill.department': '部门',
  'p.fedexfreightbill.plant': '工厂代码',
  'p.fedexfreightbill.costobject': '成本对象',
  'p.fedexfreightbill.approvaltitle': '账单审批',
  'p.fedexfreightbill.action': '是否批准',
  'p.fedexfreightbill.approved': '批准',
  'p.fedexfreightbill.rejected': '拒绝',
  'p.fedexfreightbill.remark': '运输备注',
  'p.fedexfreightbill.cargodesc': '货物描述',
  'p.fedexfreightbill.applicant': '申请人',
  'p.jdfreightbill.ordernumber': '订单编号',
  'p.jdfreightbill.referenceno': '参考编号',
  'p.jdfreightbill.trackingno':'追踪编号',
  'p.jdfreightbill.invoiceno':'预开发票编号',
  'p.jdfreightbill.freight':'运费',
  'p.jdfreightbill.freightamount':'运费金额',
  'p.jdfreightbill.othercharges': '其他费用',
  'p.jdfreightbill.amount': '金额',
  'p.jdfreightbill.currency': '货币',
  'p.jdfreightbill.shipmentdate': '发货日期',
  'p.jdfreightbill.status': '状态',
  'p.jdfreightbill.tspnumber': 'TSP编号',
  'p.jdfreightbill.shippedfrom': '发货地',
  'p.jdfreightbill.arrivedat': '到达地',
  'p.jdfreightbill.province': '省',
  'p.jdfreightbill.receivername': '收件人姓名',
  'p.jdfreightbill.receiveraddress': '收件人地址',
  'p.jdfreightbill.productname': '产品名称',
  'p.jdfreightbill.carrier': '承运人',
  'p.jdfreightbill.settletype': '结算类型',
  'p.jdfreightbill.actualdeliverydate': '实际交付日期',
  'p.jdfreightbill.quantity': '数量',
  'p.jdfreightbill.weight': '重量',
  'p.jdfreightbill.volume': '体积',
  'p.jdfreightbill.chargedweight': '计费重量',
  'p.jdfreightbill.initialweight': '初始重量',
  'p.jdfreightbill.addedweight': '附加重量',
  'p.jdfreightbill.discount': '折扣',
  'p.jdfreightbill.ensuredvalue': '保险价值',
  'p.jdfreightbill.claim': '索赔',
  'p.jdfreightbill.declarevalue': '申报价值',
  'p.jdfreightbill.effectivetime': '生效时间',
  'p.jdfreightbill.remark': '运输备注',
  'p.jdfreightbill.cargodesc': '货物描述',
  'p.jdfreightbill.company': '公司',
  'p.jdfreightbill.plant': '工厂',
  'p.jdfreightbill.department': '部门',
  'p.jdfreightbill.costobject': '成本对象',
  'p.jdfreightbill.monthlycard': '月度卡',
  'p.jdfreightbill.applicant': '申请人',
  'p.sffreightbill.invoiceno': '预开发票编号',
  'p.sffreightbill.type': '类型',
  'p.sffreightbill.freight':'运费',
  'p.sffreightbill.discountamount':'折扣金额',
  'p.sffreightbill.amount': '金额',
  'p.sffreightbill.currency': '货币',
  'p.sffreightbill.status': '状态',
  'p.sffreightbill.shippercity': '发货城市',
  'p.sffreightbill.receivercity': '收件城市',
  'p.sffreightbill.deliverydate': '交付日期',
  'p.sffreightbill.remark': '运输备注',
  'p.sffreightbill.cargodesc': '货物描述',
  'p.sffreightbill.company': '公司',
  'p.sffreightbill.plant': '工厂',
  'p.sffreightbill.department': '部门',
  'p.sffreightbill.costobject': '成本对象',
  'p.sffreightbill.monthlycard': '月度卡',
  'p.sffreightbill.ordernumber': '订单编号',
  'p.sffreightbill.referenceno': '参考编号',
  'p.sffreightbill.trackingno':'追踪编号',
  'p.sffreightbill.feetypename': '费用类型',
  'p.sffreightbill.handlername': '处理人',
  'p.sffreightbill.payableamount': '应付金额',
  'p.sffreightbill.discountAmount': '折扣金额',
  'p.sffreightbill.fee': '费用',
  'p.sffreightbill.paymentmethod': '支付方式',
  'p.sffreightbill.productname': '产品名称',
  'p.sffreightbill.vehicletypecode': '车辆类型代码',
  'p.sffreightbill.receivercontactname': '收件人联系人姓名',
  'p.sffreightbill.itemnumber': '项目编号',
  'p.sffreightbill.consignedtime': '托运时间',
  'p.sffreightbill.deliverytime': '交付时间',
  'p.sffreightbill.sourceordernumber': '源订单编号',
  'p.sffreightbill.originalordernumber': '原始订单编号',
  'p.sffreightbill.orderstatus': '订单状态',
  'p.sffreightbill.sendercontactname': '发件人联系人姓名',
  'p.sffreightbill.consignmentname': '托运名称',
  'p.sffreightbill.distance': '距离',
  'p.sffreightbill.monthlycardnumber': '月度卡编号',
  'p.sffreightbill.weight': '重量',
  'p.sffreightbill.billdate': '账单日期',
  'p.sffreightbill.discountmonthlyamount': '折扣月度金额',
  'p.sffreightbill.discountdate': '折扣日期',
  'p.sffreightbill.senderarea': '发件人地区',
  'p.sffreightbill.receiverarea': '收件人地区',
  'p.sffreightbill.othercustomername': '其他客户名称',
  'p.sffreightbill.servicename': '服务名称',
  'p.sffreightbill.serviceremark': '服务备注',
  'p.sffreightbill.sendercompanyname': '发件人公司名称',
  'p.sffreightbill.length': '长度',
  'p.sffreightbill.width': '宽度',
  'p.sffreightbill.height': '高度',
  'p.sffreightbill.receivercompanyname': '收件人公司名称',
  'p.sffreightbill.shippingtime': '发货时间',
  'p.sffreightbill.consigneeemployeenumber': '收件人员工编号',
  'p.sffreightbill.consignmentquantity': '托运数量',
  'p.sffreightbill.quantity': '数量',
  'p.sffreightbill.receiverprovince': '收件人省份',
  'p.sffreightbill.deliveremployeenumber': '发货员工编号',
  'p.sffreightbill.signedbackwaybillno': '签收回单编号',
  'p.sffreightbill.signIntime': '签到时间',
  'p.sffreightbill.additionalremark': '附加备注',
  'p.sffreightbill.additionalremark2': '附加备注 2',
  'p.sffreightbill.additionalremark3': '附加备注 3',
  'p.sffreightbill.expresscontent': '快递内容',
  'p.sffreightbill.areatype': '区域类型',
  'p.sffreightbill.senderprovince': '发件人省份',
  'p.sffreightbill.declaredvalue': '申报价值',
  'p.sffreightbill.volume': '体积',
  'p.sffreightbill.realweight': '实际重量',
  'p.sffreightbill.signInname': '签到姓名',
  'p.sffreightbill.specialweight': '特殊重量',
  'p.sffreightbill.country': '国家',
  'p.sffreightbill.returnedwaybillno': '退回运单号',
  'p.sffreightbill.applicant': '申请人',
  'p.dhlfreightbill.ordernumber': '订单编号',
  'p.dhlfreightbill.referenceno': '参考编号',
  'p.dhlfreightbill.trackingno':'追踪编号',
  'p.dhlfreightbill.invoiceno':'预开发票编号',
  'p.dhlfreightbill.freight':'运费',
  'p.dhlfreightbill.fuelsurcharge':'燃油附加费',
  'p.dhlfreightbill.otherscharge': '其他费用',
  'p.dhlfreightbill.amount': '金额',
  'p.dhlfreightbill.currency': '货币',
  'p.dhlfreightbill.shipmentdate': '发货日期',
  'p.dhlfreightbill.receivercountrycode': '收件国代码',
  'p.dhlfreightbill.shippercity': '发件城市',
  'p.dhlfreightbill.receivercity': '收件城市',
  'p.dhlfreightbill.billingmonth': '账单月份',
  'p.dhlfreightbill.company': '公司',
  'p.dhlfreightbill.monthlycard': '月度卡',
  'p.dhlfreightbill.status': '状态',
  'p.dhlfreightbill.department': '部门',
  'p.dhlfreightbill.plant': '工厂代码',
  'p.dhlfreightbill.costobject': '成本对象',
  'p.dhlfreightbill.approvaltitle': '账单审批',
  'p.dhlfreightbill.action': '是否批准',
  'p.dhlfreightbill.approved': '批准',
  'p.dhlfreightbill.rejected': '拒绝',
  'p.dhlfreightbill.remark': '运输备注',
  'p.dhlfreightbill.cargodesc': '货物描述',
  'p.dhlfreightbill.applicant': '申请人',

  'p.emsfreightbill.ordernumber': '订单编号',
  'p.emsfreightbill.referenceno': '参考编号',
  'p.emsfreightbill.trackingno':'追踪编号',
  'p.emsfreightbill.invoiceno':'预开发票编号',
  'p.emsfreightbill.freight':'运费',
  'p.emsfreightbill.fuelsurcharge':'燃油附加费',
  'p.emsfreightbill.otherscharge': '其他费用',
  'p.emsfreightbill.amount': '金额',
  'p.emsfreightbill.currency': '货币',
  'p.emsfreightbill.shipmentdate': '发货日期',
  'p.emsfreightbill.receivercountrycode': '收件国代码',
  'p.emsfreightbill.shippercity': '发件城市',
  'p.emsfreightbill.receivercity': '收件城市',
  'p.emsfreightbill.billingmonth': '账单月份',
  'p.emsfreightbill.company': '公司',
  'p.emsfreightbill.monthlycard': '月度卡',
  'p.emsfreightbill.status': '状态',
  'p.emsfreightbill.department': '部门',
  'p.emsfreightbill.plant': '工厂代码',
  'p.emsfreightbill.costobject': '成本对象',
  'p.emsfreightbill.approvaltitle': '账单审批',
  'p.emsfreightbill.action': '是否批准',
  'p.emsfreightbill.approved': '批准',
  'p.emsfreightbill.rejected': '拒绝',
  'p.emsfreightbill.remark': '运输备注',
  'p.emsfreightbill.cargodesc': '货物描述',
  'p.emsfreightbill.applicant': '申请人',
  'p.freight.trackingno':'追踪编号',
  'p.freight.invoiceno':'预开发票编号',
  'p.freight.shippercity':'发件城市',
  'p.freight.receivercity':'收件城市',
  'p.freight.dn':'DN',
  'p.freight.billingmonth':'账单月份',
  'p.freight.company':'公司',
  'p.freight.companyname': '公司名称',
  'p.freight.monthlycard':'月度卡',
  'p.freight.amount':'金额',
  'p.freight.currency':'货币',
  'p.freight.freightbilldate':'发货日期',
  'p.freight.receivercompany1':'收件公司 1',
  'p.freight.sfexrepresstype':'SF Exrepress Type',
  'p.freight.paymentmethod':'支付方式',
  'p.freight.freight':'运费',
  'p.freight.discount':'折扣',
  'p.freight.charge':'费用',
  'p.freight.shippername1':'发件人姓名 1',
  'p.freight.servicetype':'服务类型',
  //'p.freight.shippercompany':'发件公司',
  'p.freight.shippertel':'发件人电话',
  'p.freight.receivercompany2':'收件公司 2',
  'p.freight.receivertel':'收件人电话',
  'p.freight.shippername2':'发件人姓名 2',
  'p.freight.delverydate':'交付日期',
  'p.freight.originprovince':'发件省份',
  'p.freight.shippercompanyaddress':'发件公司地址',
  'p.freight.sfreceiverno':'SF Receiver No.',
  'p.freight.commodityname':'商品名称',
  'p.freight.declarevalue':'申报价值',
  'p.freight.pcs':'件数',
  'p.freight.volume':'体积',
  'p.freight.destinationprovince':'目的省份',
  'p.freight.receivername':'收件人姓名',
  'p.freight.receiveraddress':'收件人地址',
  'p.freight.sfdispatcherno':'SF Dispatcher No.',
  'p.freight.auturalweight':'实际重量',
  'p.freight.signbacktrackingno':'签收回执编号',
  'p.freight.receivedby':'收件人',
  'p.freight.receivetime':'收件时间',
  'p.freight.returnrelatedtrackingno':'退货相关追踪编号',
  'p.freight.extention1':'扩展 1',
  'p.freight.extention2':'扩展 2',
  'p.freight.extention3':'扩展 3',
  'p.freight.branchcompanyaccount':'分公司账户',
  'p.freight.orderno':'订单编号',
  'p.freight.remark':'备注',
  'p.freight.sfexpress':'顺丰快递',
  'p.freight.countrydistrict':'国家/地区',
  'p.freight.regiontype':'区域类型',
  'p.freight.length':'长度',
  'p.freight.width':'宽度',
  'p.freight.height':'高度',
  'p.freight.status':'状态',
  'p.freight.billingstatus':'账单状态',
  'p.freight.account':'账户编号',
  'p.freight.accountnumber':'发票编号',
  'p.freight.trackingnumber':'追踪编号',
  'p.freight.shipmentdate':'发货日期',
  'p.freight.shippercountrycode':'发件国',
  'p.freight.shipperthreecharactercode':'发件港',
  'p.freight.shippercityname':'发件城市',
  'p.freight.receivercountrycode':'收件国',
  'p.freight.receiverthreecharactercode':'收件港',
  'p.freight.receivercityname':'收件城市',
  'p.freight.shipperreferenceinformation':'发件人参考编号',
  'p.freight.shipperdisplayname':'发件人联系方式',
  'p.freight.shippercompany':'发件公司',
  'p.freight.shipperaddress1':'发件人地址 1',
  'p.freight.shipperaddress2':'发件人地址 2',
  'p.freight.shipperpostalcode':'发件人邮政编码',
  'p.freight.receiverdisplayname':'收件人联系方式',
  'p.freight.receivercompany':'收件公司',
  'p.freight.receiveraddress1':'收件人地址 1',
  'p.freight.receiveraddress2':'收件人地址 2',
  'p.freight.receiverpostalcode':'目的地邮政编码',
  'p.freight.quantity':'装载数量',
  'p.freight.billingweight':'计费重量',
  'p.freight.goodsvalue':'货物价值',
  'p.freight.basecharge':'基本运费',
  'p.freight.fuelsurcharge':'燃油附加费',
  'p.freight.remoteareadeliverycharge':'偏远地区派送费',
  'p.freight.overweightpricecharge':'超重货物费',
  'p.freight.nonstackablepalletcharge':'不可堆叠货物费',
  'p.freight.addresscorrectioncharge':'地址更正费',
  'p.freight.expressvalueinsurancecharge':'保价服务费',
  'p.freight.otherscharge':'其他费用',
  'p.freight.shipperpaylandtarifftax':'发件人支付的关税/税费',
  'p.freight.documentprotection':'文件保护费',
  'p.freight.emergencysurcharge':'紧急附加费',
  'p.freight.addedtax':'增值税',
  'p.freight.totalamount':'总金额',
  'p.freight.expensecode':'费用代码',
  'p.freight.expensedescription':'费用描述',
  'p.freight.area.otherchargesinfo': '费用明细',
  'p.freightbill.confirmedby': '确认人',
  'p.freightbill.confirmedtime': '确认时间',
  'p.freightbill.confirmedremark': '确认备注',
  'p.freightbill.approvedby': '批准人',
  'p.freightbill.approvedtime': '批准时间',
  'p.freightbill.approvedremark': '批准备注',
  'p.freightbill.confirmtitle': 'Bill Confirm',
  'p.freightbill.totalamount': '总金额',
  'p.freightbill.totalapproveamount': '待批准金额',
  'p.freightbill.totalconfirmamount': '待确认金额',
  'p.purchaserequest.totalnetamount': '总净价',
  'p.waybill.area.basedatainfo': '基本信息',
  'p.waybill.trackingno': '追踪编号',
  'p.waybill.createdate': '发货单创建日期',
  'p.waybill.status': '状态',
  'p.waybill.carrier': '承运人',
  'p.waybill.area.trackinginfo': '追踪信息',
  'p.print.ordernumber':'订单编号',
  'p.print.referenceno': '参考编号',
  'p.print.trackingno':'追踪编号',
  'p.print.type': '运输类型',
  'p.print.status':'状态',
  'p.print.createtime':'创建时间',
  'p.print.lastprinttime':'最后打印时间',
  'p.print.company': '公司',
  'p.print.plant': '工厂代码',
  'p.print.department': '部门',
  'p.print.carrier':'承运人',
  'p.print.cargocount': '货物数量',
  'p.print.shippercity':'发件城市',
  'p.print.receivercity':'收件城市',
  'p.print.waybilldoc':'运单文件',
  'p.print.datasourcetype':'数据来源类型',
  'p.action.cancelconfirmtitle':'取消此发货订单，您将无法再打印运单文件。请确认正确的文件已打印或DN包裹已被提取。继续取消吗？',
  'p.action.printconfirmtitle':'打印此运单文件，您将取消之前的发货订单。继续打印吗？',
  'p.action.printconfirmtitle2':'此DN有多个追踪编号。请在打印前检查信息。',
  'p.action.marknotpaytitle':'此记录将被设置为未准备好确认，并且不允许创建PO。继续此操作吗？',
  'p.action.marknotpaytitle2':'此记录将被设置为准备好确认，并且允许创建PO。继续此操作吗？',
  'p.action.sendallpotitle':'这将把{BillingMonth}（准备发送）的所有已批准货运项目发送到DPPO吗？',
  'p.action.confirmbilling.confirmtitle': '您确定要确认账单吗？',
  'p.company.name': '公司名称',
  'p.company.code': '公司代码',
  'p.company.contacts': '联系人',
  'p.company.carriers': '承运人',
  'p.company.isenabled': '是否启用',
  'p.company.taxnumber': '税号',
  'p.company.taxtype': '税务类型',
  'p.company.taxcountrycode': '税务国家代码',
  'p.company.tax': '税务编号',
  'p.company.createtitle': '创建',
  'p.department.name': '部门名称',
  'p.department.code': '部门代码',
  'p.department.company': '公司名称',
  'p.department.defaultpaymentaccount': '付款账户',
  'p.department.isenabled': '是否启用',
  'p.department.createtitle': '创建',
  'p.department.edittitle': '更新',
  'p.expressorder.area.addressinfotitle': '收货地址信息',
  'p.expressorder.postalcode': '邮政编码',
  'p.expressorder.province': '省',
  'p.expressorder.city': '市',
  'p.expressorder.area': '地区',
  'p.expressorder.address': '地址',
  'p.expressorder.contactname': '姓名',
  'p.expressorder.company': '公司',
  'p.expressorder.mobile': '手机号码',
  'p.expressorder.tel': '座机',
  'p.expressorder.email': '电子邮件',
  'p.expressorder.area.cargoinfotitle': '包裹信息',
  'p.expressorder.huIdentificationNo': 'HU识别号',
  'p.expressorder.totalweight': '重量（KG）',
  'p.expressorder.totaldimensions': '体积（CM³）',
  'p.expressorder.trackingnumber': '追踪编号',
  'p.mobile.expressorder.description': '描述',
  'p.expressorder.orderno': '订单号',
  'p.expressorder.itemno': '商品编号',
  'p.expressorder.materialname': '物料名称',
  'p.expressorder.materialdescription': '物料描述',
  'p.expressorder.quality': '品质',
  'p.expressorder.createcargoitemtitle': '添加包裹项目',
  'p.expressorder.editcargoitemtitle': '更新包裹项目',
  'p.expressorder.selectaddresstitle': '地址',
  'p.expressorder.area.orderinfotitle': '发货信息',
  'p.expressorder.area.orderregistrationtitle': '收件人税号信息',
  'p.expressorder.cnp': '税号CNP',
  'p.expressorder.dun': '税号DUN',
  'p.expressorder.ein': '税号EIN',
  'p.expressorder.eor': '税号EOR',
  'p.expressorder.fed': '税号FED',
  'p.expressorder.ftz': '税号FTZ',
  'p.expressorder.ssn': '税号SSN',
  'p.expressorder.sta': '税号STA',
  'p.expressorder.vat': '税号VAT',
  'p.expressorder.plannedshippingdatetime': '计划发货时间',
  'p.expressorder.tip': '国际运单注意事项',
  'p.pickup.tip': '取件地址填写注意事项',
  'p.expressorder.ispickuprequest': '上门取件',
  'p.expressorder.specialremarks': '运单备注',
  'p.expressorder.partnernumber': '合作伙伴编号',
  'p.expressorder.issignback': '签收回执',
  'p.expressorder.cargotype': '货物类型',
  'p.expressorder.isNeutraldelivery': '中立派送',
  'p.expressorder.cargodescription': '货物描述',
  'p.expressorder.area.baseinfotitle': '基本信息',
  'p.expressorder.plant': '工厂',
  'p.expressorder.division': '部门',
  'p.expressorder.pg': 'PG',
  'p.expressorder.costobjecttype': '成本对象类型',
  'p.expressorder.costobject': '成本对象',
  'p.expressorder.mobilephone': '手机号码',
  'p.expressorder.referenceno': '参考编号',
  'p.expressorder.carrier': '承运人',
  'p.expressorder.expresstype': '服务类型',
  'p.expressorder.estimatedcost': '预计费用',
  'p.expressorder.estimateddeliverytime': '预计交货时间',
  'p.expressorder.area.customsclearanceinfotitle': '报关信息',
  'p.expressorder.area.expressestimatedinfotitle': '运输服务预计信息',
  'p.expressorder.createexportdeclarationitemtitle': '添加出口报关项目',
  'p.expressorder.editexportdeclarationitemtitle': '更新出口报关项目',
  'p.expressorder.taxpayer': '税款/关税由谁支付',
  'p.expressorder.businessno': '商业编号',
  'p.expressorder.declarevalue': '申报价值',
  'p.expressorder.documenttype': '单证类型',
  'p.expressorder.exportdeclarationitem.description': '物料描述',
  'p.expressorder.exportdeclarationitem.itemname': '物料名称',
  'p.expressorder.exportdeclarationitem.unitprice': '单价',
  'p.expressorder.exportdeclarationitem.totalamount': '总金额',
  'p.expressorder.exportdeclarationitem.quantity': '数量',
  'p.expressorder.exportdeclarationitem.unitofmeasurement': '计量单位',
  'p.expressorder.exportdeclarationitem.manufacturercountry': '生产国',
  'p.expressorder.exportdeclarationitem.netweight': '净重(KG)',
  'p.expressorder.exportdeclarationitem.grossweight': '毛重(KG)',
  'p.expressorder.exportdeclarationitem.hscode': 'HS编码',
  'p.expressorder.exportdeclarationitem.outboundhscode': '出口HS编码',
  'p.expressorder.exportdeclarationitem.inboundhscode': '进口HS编码',
  'p.expressorder.area.invoiceinfotitle': '发票信息',
  'p.expressorder.area.invoice.lineitemstitle': '发票行项目',
  'p.expressorder.area.processinfotitle': '审批处理',
  'p.expressorder.area.approvalloginfotitle': '审批日志',
  'p.expressorder.invoice': '发票',
  'p.expressorder.taxpayer.shipper': '发货人',
  'p.expressorder.taxpayer.receiver': '收货人',
  'p.expressorder.selectcarriertitle': '选择承运服务',
  'p.expressorder.carrierservice': '承运服务',
  'p.expressorder.paymentnumber': '付款编号',
  'p.expressorder.area.carrierserviceinfotitle': '承运服务信息',
  'p.expressorder.canceltitle': '取消',
  'p.expressorder.datasource': '数据源',
  'p.expressorder.department': '部门',
  'p.addressbook.addressType': '地址类型',
  'p.addressbook.contactname': '联系人姓名',
  'p.addressbook.address': '地址',
  'p.addressbook.company': '公司名称',
  'p.addressbook.email': '电子邮件',
  'p.addressbook.companyemail': '公司/电子邮件',
  'p.expressorder.country': '国家/地区',
  'p.addressbook.mobiletel': '手机/座机',
  'p.addressbook.createtitle': '创建',
  'p.addressbook.edittitle': '更新',
  'p.addressbook.country': '国家/地区',
  'p.addressbook.countryname': '国家/地区名称',
  'p.addressbook.postalcode': '邮政编码',
  'p.addressbook.province': '省',
  'p.addressbook.city': '市',
  'p.addressbook.area': '区',
  'p.addressbook.mobile': '手机号码',
  'p.addressbook.tel': '座机',
  'p.country.name': '国家/地区',
  'p.country.nameen': '英文名称',
  'p.country.code': '编码',
  'p.country.isenabled': '是否启用',
  'p.country.createtitle': '创建',
  'p.country.edittitle': '更新',
  'p.state.country': '国家/地区',
  'p.state.name': '名称',
  'p.state.code': '编码',
  'p.state.isenabled': '是否启用',
  'p.state.createtitle': '创建',
  'p.state.edittitle': '更新',
  'p.hscode.code': 'HS编码',
  'p.hscode.description': '描述',
  'p.hscode.firstlegalunitcode': '第一法定单位',
  'p.hscode.secondlegalunitcode': '第二法定单位',
  'p.hscode.isenabled': '是否启用',
  'p.hscode.createtitle': '创建',
  'p.hscode.edittitle': '更新',
  'p.legalunit.name': '单位名称',
  'p.legalunit.code': '单位编码',
  'p.legalunit.isenabled': '是否启用',
  'p.legalunit.createtitle': '创建',
  'p.legalunit.edittitle': '更新',
  'p.expressorder.selectmaterialtitle': '请选择物料',
  'p.expressorder.ordernumber': '订单号',
  'p.expressorder.status': '状态',
  'p.expressorder.applicant': '申请人',
  'p.expressorder.applicationdate': '申请时间',
  'p.expressorder.type': '快递类型',
  'p.expressorder.reasons': '原因',
  'p.expressorder.incoterm': '国际贸易术语',
  'p.expressorder.warehouse': '仓库',
  'p.expressorder.description': '描述',
  'p.expressorder.remark': '发货原因',
  'p.expressorder.shippingremark': '发货备注',
  'p.expressorder.ensuredvalue': '保价',
  'p.expressorder.pickupdatetime': '取件时间',
  'p.expressorder.pickupremark': '取件备注',
  'p.expressorder.enablePickupAddress': '取件地址',
  'p.expressorder.package': '包裹',
  'p.expressorder.doc': '文件',
  'p.expressorder.yes': '是',
  'p.expressorder.no': '否',
  'p.expressorder.shipfrom': '发货地址',
  'p.expressorder.shipto': '收货地址',
  'p.expressorder.paymenttype': '结算方式',
  'p.expressorder.monthlycard': '月结',
  'p.expressorder.collectpayment': '到付',
  'p.expressorder.area.attachmentinfotitle': '附件信息',
  'p.expressorder.attachment': '附件',
  'p.expressorder.isUseCNABB': '是否使用CNABB账户',
  'p.sparrowtemplate.workflowname': '工作流名称',
  'p.sparrowtemplate.sparrowtoken': 'Sparrow令牌',
  'p.sparrowtemplate.sparrowappcode': 'Sparrow应用代码',
  'p.sparrowtemplate.sparrowworkflowcode': 'Sparrow工作流代码',
  'p.sparrowtemplate.sparrowpushtaskurl': 'Sparrow推送任务URL',
  'p.sparrowtemplate.isenabled': '是否启用',
  'p.sparrowtemplate.sqlscript': 'SQL脚本',
  'p.sparrowtemplate.xmltemplate': 'XML模板',
  'p.sparrowtemplate.createtitle': '创建',
  'p.sparrowtemplate.edittitle': '更新',
  'p.mobile.expressorder.remark': '原因',
  'p.mobile.addressbook.email': '电子邮件',
  'p.mobile.expressorder.shippingremark': '发货备注',
  'p.mobile.expressorder.type': "国际快递",
  'p.mobile.expressorder.ordernumber': '订单号',
  'p.mobile.expressorder.referenceno': '参考号',
  'p.mobile.expressorder.plant': '工厂',
  'p.mobile.expressorder.costobjecttype': '费用类型',
  'p.mobile.expressorder.costobject': '费用对象',
  'p.mobile.expressorder.lasttracktime': '最后操作时间',
  'p.mobile.expressorder.status': '状态',
  'p.mobile.expressorder.applicationtime': '申请时间',
  'p.mobile.expressorder.address': '地址',
  'p.mobile.expressorder.shippingdatetime': '发货时间',
  'p.mobile.expressorder.ispickuprequest': '取件',
  'p.mobile.expressorder.pickupdatetime': '取件时间',
  'p.mobile.expressorder.pickupremark': '取件备注',
  'p.mobile.expressorder.enablePickupAddress': '取件地址',
  'p.mobile.expressorder.issignback': '签收回执',
  'p.mobile.expressorder.paymenttype': '结算方式',
  'p.mobile.expressorder.cargotype': '货物类型',
  'p.mobile.expressorder.ensuredvalue': '保价',
  'p.mobile.expressorder.cargodescription': '货物描述',
  'p.mobile.expressorder.huidentificationno': 'HU编号',
  'p.mobile.expressorder.totalweight': '重量',
  'p.mobile.expressorder.totalvolume': '体积',
  'p.mobile.expressorder.packageinfotitle': '包裹信息',
  'p.mobile.expressorder.attachmentinfotitle': '附件信息',
  'p.mobile.expressorder.area.trackinfo': '追踪信息',
  'p.mobile.required': '必填',
  'p.mobile.expressorder.estimatedarrivedtimetitle': '选择承运人服务',
  'p.mobile.expressorder.estimatedcost': '费用',
  'p.mobile.expressorder.estimatedtime': '时间',
  'p.mobile.expressorder.estimatedarrivedtime': '预计到达时间',
  'p.mobile.expressorder.totalestimatedcost': '预计费用',
  'p.mobile.expressorder.cargoiteminfotitle': '货物信息',
  'p.mobile.expressorder.quantity': '数量',
  'p.mobile.expressorder.itemno': '物品编号',
  'p.mobile.expressorder.materialname': '物料名称',
  'p.mobile.expressorder.materialdescription': '物料描述',
  'p.mobile.expressorder.specialremarks': '特殊备注',
  'p.mobile.expressorder.paymentnumber': '付款编号',
  'p.mobile.expressorder.taxPayer': '税费支付方',
  'p.mobile.expressorder.declarevalue': '申报价值',
  'p.mobile.expressorder.declarecurrency': '申报货币',
  'p.mobile.addressbook.contactname': '联系人姓名',
  'p.mobile.addressbook.mobile': '手机号码',
  'p.mobile.addressbook.province': '省份',
  'p.mobile.addressbook.city': '城市',
  'p.mobile.addressbook.address': '地址',
  'p.mobile.addressbook.postalcode': '邮政编码',
  'p.mobile.addressbook.companyname': '公司',
  'p.mobile.addressbook.type': '本地地址',
  'p.mobile.addressbook.country': '国家/地区',
  'p.mobile.addressbook.provincecityarea': '省/市/区',
  'p.mobile.expressorder.exportdeclarationinfotitle': '出口报关',
  'p.mobile.exportdeclarationitem.itemname': '商品名称',
  'p.mobile.exportdeclarationitem.hscode': '海关编码',
  'p.mobile.exportdeclarationitem.unitprice': '单价',
  'p.mobile.exportdeclarationitem.totalamount': '总金额',
  'p.mobile.exportdeclarationitem.quantity': '数量',
  'p.mobile.exportdeclarationitem.unitofmeasurement': '计量单位',
  'p.mobile.exportdeclarationitem.manufacturercountry': '生产厂家',
  'p.mobile.exportdeclarationitem.netweight': '净重(KG)',
  'p.mobile.exportdeclarationitem.grossweight': '毛重(KG)',
  'p.mobile.expressorder.incoterm': '国际贸易术语',
  'p.mobile.expressorder.reason': '原因',
  'p.mobile.expressorder.invoiceinfotitle': '发票',
  'p.mobile.expressorder.documenttype': '单据类型',
  'p.mobile.expressorder.uploadtips': '支持的格式: pdf,gif,jpeg,png,tiff',
  'p.common.yes': '是',
  'p.common.no': '否',
  'p.common.copyfrom': '复制自',
  'p.process.remark': '审批备注',
  'p.home.scan': '扫描二维码到移动快递',
  'p.home.support': '支持顺丰、京东、DHL、FedEx',
  'p.dashboard.area.filter': '筛选',
  'p.dashborad.time': '实际发车日期',
  'p.dashborad.plant': '工厂',
  'p.dashborad.carrier': '承运人',
  'p.dashboard.area.datas': '数据',
  'p.dashborad.delay': '延迟天数',
  'p.dashborad.otprate': 'OTP %',
  'p.dashborad.netotd': 'Net OTD %',
  'p.dashborad.grossotdrate': 'Gross OTD %',
  'p.dashborad.huqty': '包裹数量',
  'p.dashborad.dlhu': 'D&L 包裹',
  'p.dashborad.dlrate': 'D&L %',
  'p.dashborad.domesticcost': '总计费用(CNY)',
  'p.dashborad.shipmentQTY': '发货数量',
  'p.dashborad.total': '总计',
  'p.dashboard.area.domesticcosts': '国内费用',
  'p.dashboard.area.domesticotd': '国内OTD',
  'p.dashboard.area.shipments': '按目的地发货',
  'p.common.application': '申请人',
  'p.common.applicationDate': '提交日期',
  'p.common.createdDate': '创建日期',
  'p.common.validresult': '有效状态',
  'p.expressorder.batchimportexportdeclarationitemtitle': '批量导入出口报关项',
  'p.dhlfreightbill.dataerrormessage': '数据错误信息',
  'p.fedexfreightbill.dataerrormessage': '数据错误信息',
  'p.jdfreightbill.dataerrormessage': '数据错误信息',
  'p.sffreightbill.dataerrormessage': '数据错误信息',
  'p.purchaserequest.area.attachmentinfotitle': '附件信息',
  'p.purchaserequest.attachment': '附件',
  'p.purchaserequest.edititemcostobjecttitle': '更新费用对象',
  'p.addressbook.isDefault': '默认地址',
  'p.mobile.addressbook.isdefault': '默认地址',
  'p.purchaserequest.goodsreceiptno': '货物接收单号',
  'p.expressorder.signbackattachmenttitle': '签收回执信息',
  'p.expressorder.recipientPaymentNumber': '收件人付款编号',
  'p.mobile.addressbook.recipientPaymentNumber': '收件人付款编号',
  'p.expressorder.changeshippinginfo':"更改发货信息",
  'p.expressorder.changeshippinginfo.modal.ok':"保存并提交",
  'p.delegation.delegatefrom': 'Delegate From',
  'p.delegation.delegateto': 'Delegate To',
  'p.delegation.startfrom': 'From Date',
  'p.delegation.endto': 'To Date',
  'p.delegation.remark': 'Remarks',
  'p.delegation.status': 'Status',
  'p.delegation.createdby': 'Created By',
  'p.delegation.createdtime': 'Created Time',
  'p.delegation.lastupdatedby': 'Last Updated By',
  'p.delegation.lastupdatedtime': 'Last Updated Time',
  'p.delegation.action.disableconfirmtitle': 'Are you sure you want to disable this delegation?',
  'p.delegation.action.enableconfirmtitle': 'Are you sure you want to enable this delegation?'
};
export default messages;
